import { render, staticRenderFns } from "./intellectual.vue?vue&type=template&id=89618ae8&scoped=true"
import script from "./intellectual.vue?vue&type=script&lang=js"
export * from "./intellectual.vue?vue&type=script&lang=js"
import style0 from "./intellectual.vue?vue&type=style&index=0&id=89618ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89618ae8",
  null
  
)

export default component.exports